import type { CompanyBrowserTarget } from "../company-browser/types";
import type { ContactBrowserTarget } from "../contact-browser/types";

export type CampaignCrmNavigation = {
  onOpenContact?: (target: ContactBrowserTarget) => void;
  onOpenCompany?: (target: CompanyBrowserTarget) => void;
};

export function CampaignContactLink({
  contactId,
  label,
  navigation,
}: {
  contactId: string;
  label: string;
  navigation?: CampaignCrmNavigation;
}) {
  const openContact = navigation?.onOpenContact;
  if (!openContact || !contactId || label === "—") {
    return <>{label}</>;
  }
  return (
    <button
      type="button"
      className="ghost linkish campaign-crm-link"
      onClick={() => openContact({ contact_id: contactId })}
    >
      <strong>{label}</strong>
    </button>
  );
}

export function CampaignCompanyLink({
  accountId,
  label,
  navigation,
}: {
  accountId?: string | null;
  label: string;
  navigation?: CampaignCrmNavigation;
}) {
  const openCompany = navigation?.onOpenCompany;
  if (!openCompany || !accountId?.trim() || label === "—") {
    return <>{label}</>;
  }
  return (
    <button
      type="button"
      className="ghost linkish campaign-crm-link"
      onClick={() => openCompany({ account_id: accountId.trim() })}
    >
      <strong>{label}</strong>
    </button>
  );
}
